export const filterMilestoneOrTaskStatusTypeOptionConstant = [
    { name: "Milestone Status", value: "milestone_status" },
    { name: "Task Status", value: "task_status" },
  ];